<template>
  <div class="homeGrab">
    <div class="w-1140px mx-auto c3 tracking-2px pt-58px fs16">
      <div>
        <div class="text-center pb-40px">
          <p class="fs32 font-600">产品介绍</p>
          <p class="fs22 c9">Product Introduction</p>
        </div>
        <div class="flex justify-center items-center">
          <div class="pr-35px">
            <p class="font-500 fs26">抢舱助手</p>
            <p>5个任务并发抢舱，所有客户完成企业认证即可免费使用</p>
            <el-button
              class="btn mt-32px fs20 lh10"
              type="primary"
              @click="openQQ"
              >立即体验</el-button
            >
          </div>
          <img
            width="50%"
            :src="`${ossUrl}/common/market_v2/home/grab-1.png`"
          />
        </div>
      </div>

      <div class="pt-80px">
        <div class="text-center pb-40px">
          <p class="fs32 font-600">产品能力</p>
          <p class="fs22 c9">Product Capability</p>
        </div>
        <div class="flex justify-center items-center flex-wrap">
          <div
            v-for="(v, i) in capability"
            :key="i"
            class="flex items-center mx-25px mb-40px w-520px h-136px br4"
            :style="{ 'background-color': v.bgcolor }"
          >
            <img :src="v.img" class="mx-48px" width="82px" />
            <div class="w-260px">
              <p class="font-600 pb-3px">{{ v.title }}</p>
              <p>{{ v.txt }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-40px">
        <div class="text-center pb-40px">
          <p class="fs32 font-600">产品优势</p>
          <p class="fs22 c9">Product Advantage</p>
        </div>
        <div
          v-for="(v, i) in advantage"
          :key="i"
          class="flex justify-center items-center mb-5px"
          :class="{ 'flex-row-reverse': v.first === 'img' }"
        >
          <div class="mx-40px">
            <p class="fs26 font-500 pb-2 pl-30px block">{{ v.title }}</p>
            <p v-html="v.txt"></p>
          </div>
          <img class="w-400px mx-40px" :src="v.img" />
        </div>
      </div>

      <OperationFlow
        title-z-h="使用流程"
        title-e-n="Operation Flow"
        :flow="flow"
      ></OperationFlow>
    </div>
  </div>
</template>

<script>
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
import OperationFlow from '@/components/OperationFlow'
/**
 * 无忧代理人落地页
 */
export default {
  name: 'Grab',
  components: { OperationFlow },
  data() {
    return {
      ossUrl,
      capability: [
        {
          img: `${ossUrl}/common/market_v2/home/grab-2.png`,
          title: '船司直营',
          txt: '船公司官方入驻，价格锁定，助力舱位获取',
          bgcolor: '#e7f8f2',
        },
        {
          img: `${ossUrl}/common/market_v2/home/grab-3.png`,
          title: '可视化操作',
          txt: '工作台可视化，丰富视觉效果，任务处理更迅速',
          bgcolor: '#ecf4ff',
        },
        {
          img: `${ossUrl}/common/market_v2/home/grab-4.png`,
          title: '任务管理',
          txt: '任务秒新建，基础信息和集装信息轻松管理',
          bgcolor: '#ecf6ff',
        },
        {
          img: `${ossUrl}/common/market_v2/home/grab-5.png`,
          title: '企业信息',
          txt: '企业信息及当前余额一目了然，所见即所得',
          bgcolor: '#f3f3fa',
        },
      ],
      advantage: [
        {
          first: 'txt',
          title: '免费并发任务额度',
          txt: '所有用户默认免费赠送5个并发任务的额度',
          img: `${ossUrl}/common/market_v2/home/grab-6.png`,
        },
        {
          first: 'img',
          title: '自定义抢舱优先级',
          txt: '支持用户根据ETD更接近，价格更低，<br/>库存最多的自定义优先级来制定抢舱顺序',
          img: `${ossUrl}/common/market_v2/home/grab-7.png`,
        },
        {
          first: 'txt',
          title: '数据安全全方位保护',
          txt: '采用 GlobalSign（信息安全领域全球领先的解决方案提供商）<br/>256 位高强度（安全套接层）SSL证书保障网站安全，<br/>对传输信息进行加密处理',
          img: `${ossUrl}/common/market_v2/home/grab-8.png`,
        },
      ],
      flow: [
        {
          title: '开通抢舱权限',
          txt: ['注册账号并开通企业认证，', ' 可联系客服走快速通道'],
        },
        {
          title: '新增抢舱任务',
          txt: ['点击“新建任务”，', '填写基础信息及集装箱信息即可'],
        },
        {
          title: '手机查看回执',
          txt: ['最快5分钟即可接收回执，', '手机微信接收，随时随地可处理'],
        },
      ],
    }
  },
  head() {
    return {
      title: '抢舱助手 - e航无忧',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '抢舱助手,e航无忧',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'e航无忧为国际物流行业数字化转型提供了货代操作,货代系统,海运查询,船期查询,货物跟踪,数据发送,舱单发送等一站式智能化产品及解决方案。',
        },
      ],
    }
  },
  methods: {
    openQQ,
  },
}
</script>

<style lang="scss" scoped>
.homeGrab {
  background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/rpa_2.0_home/banner-case.png);
  background-position: center calc(100% + 410px);
  background-repeat: no-repeat;
  .btn {
    width: 140px;
    height: 42px;
    background-color: #0f71ef;
    border-color: #0f71ef;
    border-radius: 4px;
  }
  .block {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 1px;
      top: 11px;
      width: 16px;
      height: 16px;
      background-color: #0f71ef;
    }
  }
}
</style>
